import React, { useImperativeHandle, useState } from 'react';
import { Drawer, DrawerProps } from 'antd';
import cls from 'classnames';
import styles from './index.module.scss';

export interface IdrawerRef {
  openDrawer: () => void;
  closeDrawer: () => void;
}

interface CustomDrawerProps extends React.PropsWithChildren<DrawerProps> {
  myRef?: any;
  renderFooter?: () => React.ReactNode;
}

const CustomDrawer: React.FC<CustomDrawerProps> = ({
  myRef,
  renderFooter,
  children,
  className,
  ...rest
}) => {
  const [visible, setVisible] = useState<boolean>(false);

  const closeDrawer = () => {
    setVisible(false);
  };

  const openDrawer = () => {
    setVisible(true);
  };

  useImperativeHandle(
    myRef,
    () => ({
      openDrawer,
      closeDrawer,
    }),
    [],
  );

  const renderFt = () => {
    if (typeof renderFooter === 'function') {
      return renderFooter();
    }
    return undefined;
  };

  return (
    <Drawer
      className={cls(styles.drawerContainer, className)}
      placement="right"
      width={980}
      footer={renderFt()}
      maskClosable={false}
      destroyOnClose
      forceRender
      visible={visible}
      onClose={closeDrawer}
      {...rest}
    >
      {children}
    </Drawer>
  );
};

export default React.forwardRef<IdrawerRef, CustomDrawerProps>((props, ref) => (
  <CustomDrawer {...props} myRef={ref} />
));
